import React, { useMemo } from "react";
import { AnimatePresence, m as motion } from "framer-motion";
import { navigate } from "gatsby";
import Button from "@/components/button";
import Container from "@/components/container";
import Link from "@/components/link";
import { useTheme } from "@/contexts/theme";
import ArrowLeftIcon from "@/icons/arrow-left";
import Logo from "@/layouts/partials/logo";
import ThemeSwitcher from "@/layouts/partials/theme-switcher";

const Header: React.FC = () => {
  const { boardVisible, showBoard, backButtonVisible } = useTheme();

  const backButtonTarget = useMemo(
    () => (typeof backButtonVisible !== "string" ? "/" : backButtonVisible),
    [backButtonVisible],
  );

  return (
    <header id="top">
      <Container className="flex items-center justify-between py-xl">
        <Link to="/" className="rounded" aria-label="kolossal Logo">
          <Logo className="w-auto h-8 md:h-10 lg:h-auto" />
        </Link>
        <div className="flex items-center gap-base">
          <AnimatePresence>
            {backButtonVisible && (
              <motion.div
                initial={{ y: 5, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
              >
                <Button
                  to={backButtonTarget}
                  type="secondary"
                  size="sm"
                  icon={ArrowLeftIcon}
                  onClick={(e: React.MouseEvent) => {
                    if (
                      window.previousLocation?.pathname === backButtonTarget
                    ) {
                      e.preventDefault();
                      navigate(-1);
                    }
                  }}
                >
                  <span className="sm:sr-only">Zurück</span>
                  <span className="hidden sm:inline" aria-hidden="true">
                    Zur Hauptseite
                  </span>
                </Button>
              </motion.div>
            )}
            {!backButtonVisible && (
              <motion.div
                className="flex items-center gap-base"
                initial={{ y: 5, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
              >
                <ThemeSwitcher className="hidden xs:inline-block" />
                <Button
                  size="sm"
                  onClick={() => showBoard(!boardVisible)}
                  className="hidden md:inline-block"
                >
                  <span className="flex items-center">
                    <span className="block w-1 h-1 mr-1.5 rounded-full bg-red supports-p3:bg-red-p3 animate-blink" />
                    <span>Words, please.</span>
                  </span>
                </Button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </Container>
    </header>
  );
};

export default Header;
